export default __webpack_public_path__ + "static/media/BentonSans-Bold.e5d79e68.woff";